<template>
  <a-spin :spinning='confirmLoading'>
    <div style="width: 100%; text-align: center;">
      <h3>方案表单库</h3>
    </div>
    <div style="float: right;">
      <a-button type="primary" style="margin-left: 10px;" @click="handleCopy" icon="copy">复制</a-button>
      <a-button type="primary" style="margin-left: 10px;" @click="handleMerge" icon="snippets">合并</a-button>
    </div>
    <div class='main-box'>
      <div class='be_choose_crf'>
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="rowSelection"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <span slot="statusAction" slot-scope="text, record">          
            <span v-if="(record.status&15)==15">已完成 </span>
            <span v-else>
              <span>已新增 </span>
              <span v-if="(record.status&2)==2">已导入 </span>
              <span v-if="(record.status&8)==8">已附件 </span>
              <span v-if="(record.status&4)==4">已分类 </span>
            </span>        
            
            <span v-if="(record.status&16)==16">已审核 </span>
            <span v-if="(record.status&32)==32">已上线 </span>
          </span>

          <span slot="action" slot-scope="text,record,index">
            <a-popconfirm title="确定删除吗?" @confirm="() => deleteSchemaForm(record)">
              <a>删除</a>
            </a-popconfirm>
            <a-divider type="vertical"/>
            <a @click="goToFormDesign(record)">编辑</a>
          </span>

        </a-table>
      </div>
    </div>

    <CsimSchemaMergeFormModal :mergeForms="selectedForms" ref="CsimSchemaMergeFormModal" @refreshFormList="refreshFormList" @clearSelectedForms="clearSelectedForms"></CsimSchemaMergeFormModal>
    <CsimSchemaCopyFormModal :mergeForms="selectedForms" ref="CsimSchemaCopyFormModal" @refreshFormList="refreshFormList" @clearSelectedForms="clearSelectedForms"></CsimSchemaCopyFormModal>
  </a-spin>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import baseRules from '@/constants/baseRules'
  import { postAction } from '@/api/manage'
  import CsimSchemaMergeFormModal from './modal/CsimSchemaMergeFormModal'
  import CsimSchemaCopyFormModal from './modal/CsimSchemaCopyFormModal'

  export default {
    name: 'CsimSchemaAttributeSelectedFormList',
    mixins:[JeecgListMixin],
    components: { 
      CsimSchemaMergeFormModal,
      CsimSchemaCopyFormModal
    },
    props: {
    },
    data() {
      return {
        model: {},
        title: '表单选择',
        disableMixinCreated: true,
        confirmLoading: false,
        isEdit: true,
        rules:{
          name:[baseRules.required],
        },
        formExclusionList:[{"id":'0',"description":"无"}],//表单排除录入条件，来自质疑配置规则数据
        // 表头
        columns: [
          {
            title: '表单',
            dataIndex: 'name',
            align: 'center',
            ellipsis: true
          },
          {
            title: '简介',
            dataIndex: 'intro',
            align: 'center',
            ellipsis: true
          },
          {
            title: '状态',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender: 'statusAction' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/scheme/page/form/list",
        },
        selectedForms: []
      }
    },
    computed: {
      rowSelection() {
        return {
          onSelect: (record, selected, selectedRows) => {
            console.log(`Selected : ${selected}`, 'Selected record: ', record);
            this.selectedForms = selectedRows;
          },
          onSelectAll: (selected, selectedRows, changeRows) => {
            console.log(`Selected : ${selected}`, 'selectedRows: ', selectedRows, 'changeRows: ', changeRows);
            this.selectedForms = selectedRows;
          },
        }
      }
    },
    created() {
    },
    methods: {
      handleSetSchema(record) {
        this.model = record;
        this.loadForm();
      },

      loadForm(){
        this.baseQueryParam.schemeId = this.model.id
        this.loadData()
      },
      deleteSchemaForm(record) {
        postAction('/scheme/form/delete?formId=' + record.id + '&schemeId=' + this.model.id, {}).then(res=>{
          if(res.success){
            this.loadForm()
          }
        }).finally(()=>{
          // todo
        })
      },

      goToFormDesign(record) {
        console.log("goToFormDesign: ", record.name);
        this.$emit("changeFormDesignTab", 'form_design', record);
      },

      handleCopy() {
        console.log("handleCopy: ", this.selectedForms);

        if (this.selectedForms.length != 1) {
          this.$message.error("请选择一个表单进行复制");
          return;
        }

        this.$refs.CsimSchemaCopyFormModal.visible = true;
        this.$refs.CsimSchemaCopyFormModal.title = "复制表单 - " + this.selectedForms[0].name;
      },

      handleMerge() {
        console.log("handleMerge: ", this.selectedForms);

        if (this.selectedForms.length < 2) {
          this.$message.error("请至少选择两个表单进行合并");
          return;
        }

        this.$refs.CsimSchemaMergeFormModal.visible = true;
        this.$refs.CsimSchemaMergeFormModal.title = "合并表单 - 总计 " + this.selectedForms.length + " 个";
      },

      refreshFormList() {
        this.loadForm();
      },

      clearSelectedForms() {
        this.selectedForms = [];
      },
    }
  }
</script>

<style lang='less' scoped>
  .visit_name_row {
    margin-bottom: 8px;
  }
  .main-box {
    padding: 12px;
  }
</style>
